import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AffiliateDisclosure() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold mb-6 text-primary-500">Affiliate Disclosure</h1>
          <div className="space-y-4 text-foreground-700 font-body leading-relaxed">
            <p>
              ClearMind Club participates in affiliate marketing programs. This means that some of the links on our website are affiliate links, and we may earn a small commission if you click on these links and make a purchase.
            </p>
            <p>
              This comes at no additional cost to you. The affiliate partnerships help us maintain and improve the quality of the content we provide to our members.
            </p>
            <p>
              We only recommend products and services that we genuinely believe will add value to our community. Our reviews and recommendations are honest and based on thorough research, regardless of any affiliate relationships.
            </p>
            <p>
              If you have any questions about our affiliate relationships, please feel free to contact us.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}